/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js.
 *
 * https://kazupon.github.io/vue-i18n/
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/locale'

import UserInfoTool from '../tools/UserInfoTool'

Vue.use(VueI18n)

const { lang } = UserInfoTool.getUserInfo()

// Change default locale here. Now available: fi, en. Put new locales in the ../locale folder.
export const i18n = new VueI18n({
  locale: lang || process.env.VUE_APP_DEFAULT_LANGUAGE,
  fallbackLocale: 'en',
  interpolation: { escapeValue: false },
  messages,
})

export default {
  i18n,
}
